export default __webpack_public_path__ + "static/media/Page21.de3d0367.txt";